module.exports = __webpack_public_path__ + "static/media/background.492d1c4e.jpg";